const headingFonts = {
	fontFace: [
		{text: 'Georgia', value: '\"Georgia\", sans-serif'}
	]
};


export { headingFonts };